import { currencyService } from '../../services/currency-service/currency-service';

export const getQuantity = ({ item, itemQty }) => {
  // If itemQty includes a '.', navigate deeply into the object using dot notation.
  if (itemQty.includes('.')) {
    return itemQty.split('.').reduce((obj, field) => (obj ? obj[field] : ''), item);
  }
  return item[itemQty]; // Direct access if no dot notation.
};

export const getItemPropertyDisplay = ({ property, item, itemQty }) => {
  const { key, value } = property;
  const lowerCaseKey = key.toLowerCase();

  switch (lowerCaseKey) {
    case 'quantity':
      return getQuantity({ item, itemQty });
    case 'price':
    case 'taxes':
    case 'duties':
      return currencyService.formatPrice(parseFloat(value));
    default:
      return value;
  }
};
